//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import posts from '~/config/posts';
import { BuildData, checkBreakpoint, getSeo } from '~/helpers';

export default {
    name: 'SingleImmobilePage',

    async asyncData({ $axios, error, $getIDBySlug, route, store, i18n }) {
        try {
            const optionsCheck = store.getters['options/CHECK_OPTIONS'];

            if (optionsCheck === false) {
                await store.dispatch('options/UPDATE_OPTIONS');
            }

            const postsLength = store.getters['posts/GET_POSTS_COUNT'];

            if (postsLength === 0) {
                await store.dispatch('posts/UPDATE_POSTS');
            }

            const slug = route.params.slug;

            if (typeof $getIDBySlug !== 'undefined') {
                const postID =
                    (await $getIDBySlug(slug, 'immobili')) || posts[slug];

                if (!postID || typeof postID !== 'number') {
                    await store.dispatch('immobile/updateData', null);

                    error({
                        statusCode: 404,
                        message: i18n.t('Ops, sembra che questa pagina non esista'),
                    });

                    return;
                }

                // Save number of sections
                const postCall = await $axios.$get(`posts/${postID}`, {
                    params: {
                        culture: i18n.locale,
                    },
                });

                if (postCall.isSuccess === false) {
                    error({
                        statusCode: 404,
                        message: i18n.t('Ops, sembra che questa pagina non esista'),
                    });

                    return;
                }

                const post =
                    postCall.isSuccess === true && postCall.payload
                        ? postCall.payload.posts[0]
                        : null;

                if (!post || post.post_type !== 'immobili') {
                    error({
                        statusCode: 404,
                        message: i18n.t('Ops, sembra che questa pagina non esista'),
                    });

                    return;
                }

                const bd = new BuildData(post, 'immobile');
                const postData = bd.build();

                await store.dispatch('immobile/updateData', post);
                await store.dispatch('ui/UPDATE_IS_PAGE_IMMOBILI', false);

                return {
                    postData,
                };
            }

            return {
                postData: null,
            };
        } catch (e) {
            console.error(e);

            error({
                statusCode: 404,
                message: i18n.t('Ops, sembra che questa pagina non esista'),
            });
        }
    },

    data: () => ({
        checkBreakpointUpXl: false,
        immagineImmobile: null,
        nomeImmobile: null,
        post: null,
        postData: null,
        sections: [],
        seo: {
            title: null,
            description: null,
            breadcrumb_title: null,
            is_robots_noindex: null,
            is_robots_nofollow: false,
            is_robots_noarchive: null,
            is_robots_noimageindex: null,
            is_robots_nosnippet: null,
            twitter_title: null,
            twitter_image: null,
            twitter_description: null,
            twitter_image_id: null,
            twitter_image_source: null,
            open_graph_title: null,
            open_graph_description: null,
            open_graph_image: null,
            open_graph_image_id: null,
            open_graph_image_source: null,
            open_graph_image_meta: null,
        },
        services: [],
        slug: null,
        tipologiaImmobile: null,
    }),

    fetch() {
        this.slug = this.$router.currentRoute.params.slug;

        this.post = this.$store.state.immobile.data;

        this.seo = this.postData.seo;

        this.sections = this.postData.sections;

        this.services = this.postData.services;

        this.nomeImmobile = this.postData.nomeImmobile;

        this.tipologiaImmobile = this.postData.tipologiaImmobile;

        this.immagineImmobile = this.postData.featuredImage;

        this.cittaImmobile = this.postData.cittaImmobile;

        this.$store.dispatch('immobile/updateInfo', {
            nomeImmobile: this.nomeImmobile,
            tipologiaImmobile: this.tipologiaImmobile,
            immagineImmobile: this.immagineImmobile,
            servizi: this.services ? { ...this.services } : null,
            prezzo: this.postData.prezzo ? { ...this.postData.prezzo } : null,
        });

        this.$store.dispatch(
            'ui/UPDATE_IS_COVER_FIRST_SECTION',
            this.postData.isCoverFirstSection
        );
    },

    head() {
        if (this.seo === null || typeof this.seo === 'undefined') {
            return;
        }

        const fullPath = this.$route.fullPath;

        const baseURL = this.$config.BASE_URL || 'https://www.libertyhomes.it/';

        const currentURL = `${baseURL}${String(fullPath).replace(/^\//, '')}`;

        const headToReturn = getSeo(this.seo, currentURL, true);

        return { ...headToReturn };
    },

    mounted() {
        this.checkBreakpointUpXl = checkBreakpoint.up('xl');
    },

    // async destroyed() {
    //   await this.$store.dispatch( 'immobile/updateData', null );
    // }

    methods: {
        ...mapActions([
            'ui/UPDATE_IS_COVER_FIRST_SECTION',
            'ui/UPDATE_IS_PAGE_IMMOBILI',
        ]),
    },
};
